export default __webpack_public_path__ + "static/media/garufa-members-concert.cd486b33.jpg";